export default {
    create_device_model_create_title: "New Device Model",
    create_device_model_edit_title: "Edit Device Model",
    create_device_model_create_success_message: "The device model has been created",
    create_device_model_update_success_message: "The device model has been edited",
    create_device_model_manufacturer: "Manufacturer",
    create_device_model_name: "Name",
    create_device_model_product: "Product",
    create_device_model_system: "System",
    create_device_model_network: "Network",
    create_device_model_inputs: "Number of Inputs",
    create_device_model_ouputs: "Number of Ouputs",
    create_device_model_initial_battery: "Initial Battery",
    create_device_model_mark_initial_battery: "Set initial battery",
    create_device_model_options: "Options",
    create_device_model_ota: "OTA",
    create_device_model_sms: "SMS",
    create_device_model_starter: "Starter",
    create_device_model_driver_behavior: "Driver Behavior",
    create_device_model_analytic: "Analytic",
    create_device_model_uses_sim: "Uses SIM",
    create_device_model_motion: "Motion",
    create_device_model_obd2_alerts: "OBDII Alerts",
    create_device_model_hours_enable: "Hours Enable",
    create_device_model_odometer_enable: "Odometer Enable",
    create_device_model_promiles: "Promiles",
    create_device_model_comdata: "Comdata",
    create_device_model_pressure_pro: "Pressure Pro",
    create_device_model_vbus: "V-Bus",
    create_device_model_jbus: "J-Bus",
    create_device_model_tow: "Tow",
    create_device_model_ttu: "TTU",
    create_device_model_tso: "TSO",
    create_device_model_version: "Version",
    create_device_model_geofence: "Geofence",
    create_device_model_max_geofences: "Max Geofences",
    create_device_model_type: "Type",
    create_device_model_support_geofences: "Support Geofences",
    create_device_model_polygon: "Polygon",
    create_device_model_regular_shape: "Regular Shape",
    create_device_model_max_points: "Max Points",
    create_device_model_square: "Square",
    create_device_model_circle: "Circle",
    create_device_model_unit_type: "Unit Type",
    create_device_model_geofence_type_missing: "You must select geofence polygon, square, circle or all",
    create_device_model_geofence_form_missing: "You must select the form of the geofence that can be square, circle or both",
    create_device_model_min_points: "The minimum # of point is 3",
    create_device_model_max_points_error: "The maximum # of point is ",
    create_device_model_min_geofences: "The minimum # of geofences is 1",
    create_device_model_max_geofences_error: "The maximum # of geofences is ",
    create_device_model_min_number: "The minimum # required is",
    create_device_model_max_number: "The maximum # required is",
    create_device_model_tab_general: "General Info",
    create_device_model_tab_options: "Options",
    create_device_model_tab_Geofences: "Geofences",
    create_device_model_tab_alert_types: "Alert Types Supported",
    create_device_model_carb: "Carb",

}